module.exports = __webpack_public_path__ + "static/media/rank-01-newbie.2d6bdb19.svg";